export default __webpack_public_path__ + "static/media/SONGPRO_360_mobile.7041da0e.jpg";